class ReviewAggregate extends HTMLElement {
  set data(value) {
    this.render(value);
  }

  constructor() {
    super();

    if (Shopify?.designMode) {
      this.mockData();
    } else {
      this.fetchData();
    }
  }

  render(data) {
    const { ratingAndReviewCount, ratingAndReviewCountByLevel, ratingAndReviewValuesTotal } = data;

    if (ratingAndReviewCount === 0) {
      this.innerHTML = "";
      return;
    }

    const averageRating = (ratingAndReviewValuesTotal / ratingAndReviewCount).toFixed(1);
    const percentageRating = ((averageRating / 5) * 100).toFixed(1);

    const TotalRatingStarsSvg = () => `
      <svg width="90" height="18" fill="none" viewBox="0 0 90 18">
        <g fill="#d9d4d2" clip-path="url(#a)">
          <use href="#star" x="0" />
          <use href="#star" x="18" />
          <use href="#star" x="36" />
          <use href="#star" x="54" />
          <use href="#star" x="72" />
        </g>
        <g fill="#26000b" clip-path="url(#mask)">
          <use href="#star" x="0" />
          <use href="#star" x="18" />
          <use href="#star" x="36" />
          <use href="#star" x="54" />
          <use href="#star" x="72" />
        </g>
        <defs>
          <symbol id="star" width="18" height="18" viewBox="0 0 18 18">
            <path d="M9 11.806 6.207 13.45a.4.4 0 0 1-.228.048.5.5 0 0 1-.204-.07.4.4 0 0 1-.15-.17.32.32 0 0 1-.01-.24l.743-3.083L3.9 7.857a.4.4 0 0 1-.136-.197.3.3 0 0 1 .014-.22.5.5 0 0 1 .127-.172.46.46 0 0 1 .215-.089l3.244-.276 1.264-2.92a.35.35 0 0 1 .151-.178A.45.45 0 0 1 9 3.75a.45.45 0 0 1 .222.055.34.34 0 0 1 .15.178l1.265 2.92 3.243.276q.135.022.216.09a.5.5 0 0 1 .127.171q.047.106.014.22a.4.4 0 0 1-.137.197l-2.457 2.078.743 3.084a.3.3 0 0 1-.009.238.38.38 0 0 1-.151.17.5.5 0 0 1-.204.071.4.4 0 0 1-.228-.048z"/>
          </symbol>
          <clipPath id="mask">
            <rect width="${percentageRating}%" height="18" />
          </clipPath>
        </defs>
      </svg>
    `;

    const RatingLevel = (level) => {
      const count = ratingAndReviewCountByLevel[`level${level}Count`] || 0;
      const percentage = ratingAndReviewCount ? ((count / ratingAndReviewCount) * 100).toFixed(1) : 0;
      return `
        <div class="review-aggregate__level">
          <div class="review-aggregate__level-label">
            ${level}
            <svg  width="16" height="16" viewBox="0 0 18 18">
              <path d="M9 11.806 6.207 13.45a.4.4 0 0 1-.228.048.5.5 0 0 1-.204-.07.4.4 0 0 1-.15-.17.32.32 0 0 1-.01-.24l.743-3.083L3.9 7.857a.4.4 0 0 1-.136-.197.3.3 0 0 1 .014-.22.5.5 0 0 1 .127-.172.46.46 0 0 1 .215-.089l3.244-.276 1.264-2.92a.35.35 0 0 1 .151-.178A.45.45 0 0 1 9 3.75a.45.45 0 0 1 .222.055.34.34 0 0 1 .15.178l1.265 2.92 3.243.276q.135.022.216.09a.5.5 0 0 1 .127.171q.047.106.014.22a.4.4 0 0 1-.137.197l-2.457 2.078.743 3.084a.3.3 0 0 1-.009.238.38.38 0 0 1-.151.17.5.5 0 0 1-.204.071.4.4 0 0 1-.228-.048z"/>
            </svg>
          </div>
          <div class="review-aggregate__level-bar-wrap">
            <div class="review-aggregate__level-bar" style="width: ${percentage}%;"></div>
          </div>
          <div class="review-aggregate__level-count light">${count}</div>
        </div>
      `;
    };

    this.innerHTML = `
      <div class="review-aggregate__header">
        <div class="h4">${averageRating}</div>
        <div>${TotalRatingStarsSvg(percentageRating)}</div>
        <div class="light">Based on ${ratingAndReviewCount} reviews</div>
      </div>
      <div>
        ${[5, 4, 3, 2, 1].map(RatingLevel).join("")}
      </div>
    `;
  }

  async fetchData() {
    const subscriberId = this.getAttribute("subscriber-id");
    const productId = this.getAttribute("product-id");

    try {
      const endpoint = `https://api.okendo.io/v1/stores/${subscriberId}/products/shopify-${productId}/review_aggregate`;
      const response = await fetch(endpoint);
      const json = await response.json();

      this.data = json?.reviewAggregate;
    } catch (error) {
      console.error("Error setting up Okendo review fetch:", error);
    }
  }

  mockData() {
    this.data = {
      ratingAndReviewCount: 4,
      ratingAndReviewCountByLevel: {
        level3Count: 1,
        level4Count: 1,
        level5Count: 2,
      },
      ratingAndReviewValuesTotal: 17,
    };
  }
}

if (!customElements.get("review-aggregate")) {
  customElements.define("review-aggregate", ReviewAggregate);
}
